export const blockIconsSocialHandshakeNew = (
	<span className='material-symbols-outlined'>handshake</span>
);
